import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth.jsx';
import { useT } from './lib/i18n.jsx';
import { ToastHost } from './lib/toast.jsx';
import Topbar from './components/Topbar.jsx';
import LoginPage from './pages/Login.jsx';
import VerifyEmail from './pages/public/VerifyEmail.jsx';
import ResetPassword from './pages/public/ResetPassword.jsx';
import AcceptInvite from './pages/public/AcceptInvite.jsx';
import Dashboard from './pages/Dashboard.jsx';
import HostingList from './pages/hosting/HostingList.jsx';
import HostingDetail from './pages/hosting/HostingDetail.jsx';
import DomainsPage from './pages/domains/DomainsPage.jsx';
import EmailList from './pages/email/EmailList.jsx';
import EmailDetail from './pages/email/EmailDetail.jsx';
import BackupsPage from './pages/backups/BackupsPage.jsx';
import BackupsDetail from './pages/backups/BackupsDetail.jsx';
import BillingPage from './pages/billing/BillingPage.jsx';
import BillingDetail from './pages/billing/BillingDetail.jsx';

function ProtectedShell() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const t = useT();
  if (loading) return <div className="page-loader">{t('common.loading')}</div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return (
    <>
      <Topbar />
      <Outlet />
    </>
  );
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Public pages linked from the API's e-mails (customer_portal_url). */}
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route element={<ProtectedShell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/domeinen" element={<DomainsPage />} />
          <Route path="/domeinen/:domain" element={<DomainsPage />} />
          <Route path="/hosting" element={<HostingList />} />
          <Route path="/hosting/:id" element={<HostingDetail />} />
          <Route path="/e-mail" element={<EmailList />} />
          <Route path="/e-mail/:id" element={<EmailDetail />} />
          <Route path="/backups" element={<BackupsPage />} />
          <Route path="/backups/:id" element={<BackupsDetail />} />
          <Route path="/facturatie" element={<BillingPage />} />
          <Route path="/facturatie/:id" element={<BillingDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <ToastHost />
    </>
  );
}
